var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    transform: "translate(-41 -313)",
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 700,
    transform: "translate(-41 -162)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -41,
    y: -228,
    width: 375,
    height: 628,
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 700,
    transform: "translate(-41 -162)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20.5,
    y: -16.5,
    width: 336,
    height: 73,
    rx: 10.5,
    fill: "#F8F9F9",
    stroke: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.997 23.5723C15.1447 23.5723 11 24.3373 11 27.3974C11 30.4586 15.1188 31.2507 19.997 31.2507C24.8493 31.2507 28.9939 30.4868 28.9939 27.4255C28.9939 24.3643 24.8763 23.5723 19.997 23.5723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9967 20.6574C23.3021 20.6574 25.9504 18.008 25.9504 14.7037C25.9504 11.3995 23.3021 8.75 19.9967 8.75C16.6924 8.75 14.043 11.3995 14.043 14.7037C14.043 18.008 16.6924 20.6574 19.9967 20.6574Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white",
    transform: "translate(-41 -313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.54953ea79180e7d3891aaf3f8c31336a.svg";
export { ForwardRef as ReactComponent };